const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-tile-list-medium-image'] = {
        c: () => require('partner/modules/moe-tile-list-medium-image/moe-tile-list-medium-image.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-tile-list-medium-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-tile-list-medium-image'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-tile-list-medium-image|moe-tile-list-medium-image'] = {
                c: () => require('partner/modules/moe-tile-list-medium-image/moe-tile-list-medium-image.view.tsx'),
                cn: '__local__-__local__-moe-tile-list-medium-image'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };